import {ReviewList} from "./reviewlist";
import {ReviewItemMobile} from "./reviewitemmobile";

export class ReviewListMobile extends ReviewList{
	/**
     * @param {array} items
	 * @return {array}
     * @private
     */
    _prepareItems(items) {
    	return items.map(r => {
            r.parent = this;
            return new ReviewItemMobile(r);
        });
	}

    /**
     * @param {ReviewItem} item
     * @private
     */
    _handleItemClick(item) {
        if(!this.isDetails) {
            window.open(item.data().url, '_blank');
        }
    }
}



// WEBPACK FOOTER //
// ./modules/reviews/common/model/reviewlistmobile.js